import api from '../api'
import * as mutationTypes from './mutation-types'

const mutations = {
  [mutationTypes.SET_SUBMISSION_DATA](state, submissionData) {
    state.submissionData = submissionData
  },
}

const actions = {
  async fetchSubmissionDropdownData({ commit, _state }) {
    const submissionData = await api.fetchSubmissionDropdownData()

    commit(mutationTypes.SET_SUBMISSION_DATA, submissionData)
  },
}

export default {
  state() {
    return {
      submissionData: [],
    }
  },
  mutations,
  actions,
}
